import React, { useState, useEffect } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import './ComingSoon.css';
import Logo from '../../Images/RecoveryCenterLogo.PNG';

const LockIcon = () => (
  <svg className="lock-icon" viewBox="0 0 24 24">
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3-7H9V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2z"/>
  </svg>
);

const ComingSoonT = () => {
  const [email, setEmail] = useState('');
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [screenSize, setScreenSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200,
    height: typeof window !== 'undefined' ? window.innerHeight : 800
  });
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    total: 0
  });

  // Replace with your actual GymMaster username
  const GYMMASTER_SIGNUP_URL = 'https://therec.gymmasteronline.com/portal/login';

  // Set your grand opening date
  const grandOpeningDate = new Date('2025-07-30T08:00:00-06:00');

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const target = grandOpeningDate.getTime();
      const difference = target - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds, total: difference });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0, total: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    window.addEventListener('resize', handleResize);

    return () => {
      clearInterval(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, [grandOpeningDate]);

  const handleDirectSignup = () => {
    setIsRedirecting(true);
    setTimeout(() => {
      window.open(GYMMASTER_SIGNUP_URL, '_blank');
      setIsRedirecting(false);
    }, 500);
  };

  const renderTime = (dimension, time) => {
    return (
      <div className="time-wrapper">
        <div className="time">{String(time).padStart(2, '0')}</div>
        <div className="dimension">{dimension}</div>
      </div>
    );
  };

  // Dynamic sizing based on screen size and container
  const getTimerConfig = () => {
    const { width } = screenSize;
    
    if (width <= 320) {
      return { size: 60, strokeWidth: 3 };
    } else if (width <= 480) {
      return { size: 70, strokeWidth: 4 };
    } else if (width <= 768) {
      return { size: 80, strokeWidth: 4 };
    } else if (width <= 1024) {
      return { size: 90, strokeWidth: 5 };
    } else if (width <= 1200) {
      return { size: 100, strokeWidth: 6 };
    } else {
      return { size: 110, strokeWidth: 6 };
    }
  };

  const { size, strokeWidth } = getTimerConfig();

  const services = [
    { icon: '❄️', name: 'Cold Plunge', description: 'Arctic recovery therapy' },
    { icon: '🔥', name: 'Infrared Sauna', description: 'Deep tissue restoration' },
    { icon: '🔄', name: 'Contrast Therapy', description: 'Hot/cold treatment' },
    { icon: '💪', name: 'Compression', description: 'Recovery enhancement' },
    { icon: '〰️', name: 'Percussion', description: 'Targeted muscle relief' },
    { icon: '🧘', name: 'Recovery Lounge', description: 'Relaxation space' },
  ];

  return (
    <div className="coming-soon-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <div className="gradient-overlay"></div>
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
          </div>
        </div>
        
        <div className="hero-container">
          <div className="hero-content">
            <div className="content-wrapper">
              
              {/* Logo Section */}
              <div className="brand-section">
                <div className="logo-container">
                  <img src={Logo} alt="The Recovery Center - Recover. Recharge. Perform." className="hero-logo" />
                </div>
              </div>

              {/* Status Badge */} {/*
              <div className="status-badge">
                <div className="badge-pulse"></div>
                <span>Coming Soon</span>
              </div> */}

              {/* Main Content */}
              <div className="main-content">
                <h1 className="hero-title">
                  Revolutionize Your
                  <span className="gradient-text"> Recovery</span>
                </h1>
                
                <p className="hero-subtitle">
                  Experience the future of wellness with cutting-edge recovery therapies. 
                  Professional-grade solutions designed for optimal performance and restoration.
                </p>
              </div>

              {/* Responsive Countdown Timer */}
              <div className="countdown-section">
                {timeLeft.total > 0 ? (
                  <div className="countdown-container">
                    <h2 className="countdown-title">Coming Soon!</h2>
                    <div className="countdown-wrapper">
                      <div className="countdown-grid">
                        <div className="countdown-item">
                          <CountdownCircleTimer
                            isPlaying
                            duration={86400}
                            colors={["#4299e1"]}
                            size={size}
                            strokeWidth={strokeWidth}
                            initialRemainingTime={timeLeft.days * 86800}
                            key={`days-${timeLeft.days}-${size}`}
                            onComplete={() => ({ shouldRepeat: false })}
                          >
                            {() => renderTime("Days", timeLeft.days)}
                          </CountdownCircleTimer>
                        </div>

                        <div className="countdown-item">
                          <CountdownCircleTimer
                            isPlaying
                            duration={24}
                            colors={["#63b3ed"]}
                            size={size}
                            strokeWidth={strokeWidth}
                            initialRemainingTime={timeLeft.hours}
                            key={`hours-${timeLeft.hours}-${size}`}
                            onComplete={() => ({ shouldRepeat: true, delay: 1 })}
                          >
                            {() => renderTime("Hours", timeLeft.hours)}
                          </CountdownCircleTimer>
                        </div>

                        <div className="countdown-item">
                          <CountdownCircleTimer
                            isPlaying
                            duration={60}
                            colors={["#93c5fd"]}
                            size={size}
                            strokeWidth={strokeWidth}
                            initialRemainingTime={timeLeft.minutes}
                            key={`minutes-${timeLeft.minutes}-${size}`}
                            onComplete={() => ({ shouldRepeat: true, delay: 1 })}
                          >
                            {() => renderTime("Min", timeLeft.minutes)}
                          </CountdownCircleTimer>
                        </div>

                        <div className="countdown-item">
                          <CountdownCircleTimer
                            isPlaying
                            duration={60}
                            colors={["#60a5fa"]}
                            size={size}
                            strokeWidth={strokeWidth}
                            initialRemainingTime={timeLeft.seconds}
                            key={`seconds-${timeLeft.seconds}-${size}`}
                            onComplete={() => ({ shouldRepeat: true, delay: 1 })}
                          >
                            {() => renderTime("Sec", timeLeft.seconds)}
                          </CountdownCircleTimer>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="countdown-completed">
                    <h2>🎉 We're Open! 🎉</h2>
                    <p>Welcome to the future of recovery</p>
                  </div>
                )}
              </div>

              {/* CTA Section - Fixed Alignment */}
              <div className="cta-section">
                <div className="cta-content">
                  <h3 className="cta-heading">Pre-Register for Exclusive Opening Deals!</h3>
                  <p className="cta-description">
                    Sign up now to secure founding member pricing and be first to book your recovery sessions.
                  </p>

                  {/* Direct Signup Button - Properly Centered */}
                  <div className="cta-button-container">
                    <button 
                      onClick={handleDirectSignup}
                      className="cta-button"
                      disabled={isRedirecting}
                    >
                      {isRedirecting ? (
                        <>
                          <span className="spinner"></span>
                          Redirecting...
                        </>
                      ) : (
                        'Early Bird Registration!'
                      )}
                    </button>
                  </div>
                  
                  <p className="privacy-notice">
                    <LockIcon/> Secure registration powered by GymMaster
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview Section */}
      <section className="services-preview-section">
        <div className="services-container">
          <div className="section-header">
            <h2>What's Coming</h2>
            <p>Professional recovery solutions designed for peak performance</p>
          </div>
          
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card" style={{animationDelay: `${index * 0.1}s`}}>
                <div className="service-icon">{service.icon}</div>
                <div className="service-content">
                  <h3 className="service-name">{service.name}</h3>
                  <p className="service-description">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ComingSoonT;
